import { render, staticRenderFns } from "./notifications-list.vue?vue&type=template&id=4351f9da&scoped=true"
import script from "./notifications-list.vue?vue&type=script&lang=js"
export * from "./notifications-list.vue?vue&type=script&lang=js"
import style0 from "./notifications-list.vue?vue&type=style&index=0&id=4351f9da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351f9da",
  null
  
)

export default component.exports